<template>
  <div>
    <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
    <b-form-tags
      @input="(value) => $emit('tagChange', value)"
      :value="value"
      size="lg"
      class="mb-2"
      add-on-change
      no-outer-focus
    >
      <template
        #default="{ tags, inputAttrs, inputHandlers, disabled, removeTag }"
      >
        <b-form-select
          v-bind="inputAttrs"
          v-on="inputHandlers"
          :disabled="disabled || availableOptions.length === 0"
          :options="availableOptions"
          class="mb-2"
        >
          <template #first>
            <!-- This is required to prevent bugs with Safari -->
            <option disabled value="">{{ placeholder }}</option>
          </template>
        </b-form-select>
        <ul v-if="tags.length > 0" class="list-inline d-inline-block">
          <li v-for="tag in tags" :key="tag" class="list-inline-item">
            <b-form-tag
              @remove="removeTag(tag)"
              :title="tag"
              :disabled="disabled"
              variant="info"
              >{{ tag }}</b-form-tag
            >
          </li>
        </ul>
        <div class="d-flex justify-content-end">
          <b-button
            @click="$emit('tagChange', options)"
            variant="link"
            class="m-1"
            size="sm"
            >Select All</b-button
          >
          <b-button
            @click="$emit('tagChange', [])"
            variant="link text-danger"
            class="m-1"
            size="sm"
            >Remove All</b-button
          >
        </div>
      </template>
    </b-form-tags>
  </div>
</template>

<script>
// Taken from example here and modified
// https://bootstrap-vue.org/docs/components/form-tags#form-tags
export default {
  name: 'MultiSelect',
  props: {
    options: Array,
    value: Array,
    placeholder: {
      type: String,
      default: 'Choose a tag...',
    },
  },
  emits: ['tagChange'],
  computed: {
    availableOptions() {
      return this.options.filter((opt) => this.value.indexOf(opt) === -1);
    },
  },
};
</script>
